import PageNotFound from 'pages/ErrorPages/PageNotFound/PageNotFound';

export default PageNotFound;
